import React from "react";
import { AlertCircle } from "lucide-react";

export const API = process.env.REACT_APP_BACKEND_URL + "/api";
export const POLLING_INTERVAL_MS = 30000;

export const formatDate = (d) => {
  if (!d) return "—";
  try { return new Date(d).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }); }
  catch { return d; }
};

export const StatusBadge = (status) => (
  <span className={`px-2 py-1 rounded-full text-xs font-medium ${
    status === "completed" ? "bg-green-100 text-green-700" : "bg-yellow-100 text-yellow-700"
  }`}>{status}</span>
);

export const AppointmentStatusBadge = (status) => {
  const styles = {
    pending_confirmation: "bg-amber-100 text-amber-700",
    confirmed: "bg-green-100 text-green-700",
    completed: "bg-blue-100 text-blue-700"
  };
  const labels = {
    pending_confirmation: "Pending",
    confirmed: "Confirmed",
    completed: "Completed"
  };
  return (
    <span className={`px-2 py-1 rounded-full text-xs font-medium ${styles[status] || "bg-gray-100 text-gray-700"}`}>
      {labels[status] || status}
    </span>
  );
};

export const StatCard = ({ icon: Icon, label, value, color }) => (
  <div data-testid={`stat-${label.toLowerCase().replace(/\s/g, '-')}`}
    className="bg-white rounded-2xl p-6 border border-emerald_deep/5 shadow-sm">
    <div className={`w-10 h-10 rounded-xl ${color} flex items-center justify-center mb-3`}>
      <Icon size={18} className="text-white" />
    </div>
    <p className="text-3xl font-serif text-emerald_deep font-semibold">{value}</p>
    <p className="text-sm text-text_muted mt-1">{label}</p>
  </div>
);

export const DataTable = ({ title, data, columns, emptyMsg, testId }) => (
  <div data-testid={testId} className="bg-white rounded-2xl border border-emerald_deep/5 shadow-sm overflow-hidden">
    <div className="px-6 py-4 border-b border-emerald_deep/5">
      <h3 className="font-serif text-xl text-emerald_deep">{title}</h3>
    </div>
    {data.length === 0 ? (
      <div className="p-8 text-center text-text_muted">
        <AlertCircle size={24} className="mx-auto mb-2 opacity-40" />
        <p className="text-sm">{emptyMsg}</p>
      </div>
    ) : (
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-bone">
            <tr>{columns.map(col => <th key={col.key} className="px-4 py-3 text-left text-xs uppercase tracking-wider text-text_muted font-medium">{col.label}</th>)}</tr>
          </thead>
          <tbody className="divide-y divide-emerald_deep/5">
            {data.map((row, i) => (
              <tr key={row.id || row.razorpay_order_id || `row-${i}`} className="hover:bg-bone/50 transition-colors">
                {columns.map(col => (
                  <td key={col.key} className="px-4 py-3 text-text_main whitespace-nowrap">
                    {col.render ? col.render(row[col.key], row) : (row[col.key] || "—")}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);
